// extracted by mini-css-extract-plugin
export var brand = "_6o-9";
export var compact = "_6o-6";
export var extraSmall = "_6o-7";
export var icon = "_6o-0";
export var large = "_6o-4";
export var light = "_6o-1";
export var medium = "_6o-5";
export var outline = "_6o-b";
export var primaryDark = "_6o-a";
export var primaryLight = "_6o-8";
export var primaryModern = "_6o-c";
export var success = "_6o-2";
export var successSolid = "_6o-3";